import type { IndexUiState } from 'instantsearch.js'
import { useMemo } from 'react'
import {
  Configure,
  InstantSearch,
  type InstantSearchProps
} from 'react-instantsearch'
import { nowCeilHour } from '../../../../assets/constants/datetime'
import createSearchClient from '../../../../assets/utils/algolia/createSearchClient'
import { type IndexName, useConfigContext } from './ConfigContext'
import SearchUI from './SearchUI'

const instantSearchProps = {
  future: {
    preserveSharedStateOnUnmount: true
  },
  insights: false
} as const satisfies Partial<InstantSearchProps>

type TUiState = {
  [Key in IndexName]: IndexUiState
}

export type AppProps<TRouteState = TUiState> = {
  routing?: InstantSearchProps<TUiState, TRouteState>['routing']
}
export default function App<TRouteState = TUiState>({
  routing
}: AppProps<TRouteState>) {
  const { appId, apiKey, postsPerPage, indexName, locale } = useConfigContext()

  const searchClient = useMemo(() => {
    return createSearchClient(appId, apiKey)
  }, [appId, apiKey])

  const filters = useMemo(
    () => `date < ${nowCeilHour()} AND availableLanguages:"${locale}"`,
    [locale]
  )

  return (
    <InstantSearch
      {...instantSearchProps}
      indexName={indexName}
      routing={routing}
      searchClient={searchClient}
    >
      <Configure
        hitsPerPage={postsPerPage}
        getRankingInfo
        filters={filters}
      />
      <SearchUI />
    </InstantSearch>
  )
}
